jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').remove();

	var polyfillMultiselects = function () {
		$('select[multiple]').multiselect().on('focus blur reset', function (e) {
			$(this).parents('.pagecreator_formelement').eq(0).css('z-index', e.type === 'focus' ? 11 : '');

			if (e.type === 'reset') {
				$(this).next().find('.active').removeClass('active');
				setTimeout(function () {
					$(this).val('');
				}.bind(this), 10);
			}
		});
	};
	polyfillMultiselects();

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	$html.on({
		ready: function() {
			polyfillPlaceholders();
			polyfillMultiselects();
			polyfillMultirange();
		}
	}, '.pagecreator_filter');

	$html.on({
		ready: function() {
			setTimeout(function() {
				$(this).prev().find('[data-counter]').text($(this).find('.article').length);
			}.bind(this), 1);
		}
	}, '.posttypelist_default--location').find('.posttypelist_default--location').trigger('ready');

	/**
	 * add id "page-title" to very first headline we find
	 */
	let pageTitle = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
	if(pageTitle.length) {
		// find first visible headline
		pageTitle = Array.from(pageTitle).find(h => h.offsetHeight);
		if(pageTitle) {
			pageTitle.id = 'page-title';
		}
	}

	/**
	 * add listeners for jumpnavigation between posts of history
	 */
	// if we're at the end of the page after scrolling, add affix-bottom to .container-footer, else remove it
	$(document).on('scroll', function() {
		let $footer = $('.container-footer');
		if($(document).scrollTop() + $(window).height() >= $(document).height()) {
			$footer.addClass('affix-bottom');
		} else {
			$footer.removeClass('affix-bottom');
		}
	});

	$('.scroll-top-button').on({
		click: function() {
			$(document).scrollTop(0);
			return false;
		}
	});

	// on [cmd]+[g] add debug class to container-content
	let $content = $('.container-content');
	$(document).on('keydown', function(e) {
		if(e.key === 'g' && e.metaKey) {
			$content.toggleClass('debug');
			// add state to local storage
			sessionStorage.setItem('debug', $content.hasClass('debug'));

			return false;
		}
	});
	// check local storage for debug state
	if(sessionStorage.getItem('debug') === 'true') {
		$content.addClass('debug');
	}
});
